import { render, staticRenderFns } from "./GuidedQuizScreen.vue?vue&type=template&id=58fe45aa&scoped=true&"
import script from "./GuidedQuizScreen.vue?vue&type=script&lang=js&"
export * from "./GuidedQuizScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fe45aa",
  null
  
)

export default component.exports